import React from 'react'
import InvoiceGeneratorInfo from '../components/InvoiceGeneratorInfo'

const InfoPage: React.FC = () =>{
    return (
        <InvoiceGeneratorInfo></InvoiceGeneratorInfo>
    )
    
}
export default InfoPage;